import LoginImage from "../../assets/images/imageLogin.jpeg";
import LoginLogoImage from "../../assets/images/logoLoginImage.webp";
import * as React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";

import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { Grid } from "@mui/material";
//import { useNavigate, useLocation } from "react-router-dom";
import { useState } from "react";
import { Typography } from "@mui/material";
import LabelTypography from "../../components/Typography/LabelTypography";
import ButtonSimple from "../../components/Button/ButtonSimple";
import { Divider } from "@mui/material";
import LinkTypography from "../../components/Typography/LinkTypography";

import { useAuth } from "../../services/AuthServices";

// TODO remove, this demo shouldn't need to reset the theme.

function Login() {
  //  const Navigate = useNavigate();
  //const location = useLocation();
  //  const fromPath = location.state?.form;
  //  const queryParams = new URLSearchParams(location.search);
  //  const redirectPath = queryParams.get("redirect");
  const [emailError, setEmailError] = useState(null);
  const [passwordError, SetPasswordError] = useState(null);
  const { login } = useAuth();

  const handleSubmit = async (event) => {
    event.preventDefault();
    InisialState();
    const data = {
      email: event.target.email.value,
      password: event.target.password.value,
    };
    /*    console.log(!CheckEmailRegulaire(data.email));
    if (!CheckEmailRegulaire(data.email)) {
      setEmailError("Invalid email");
      return;
    }
    if (data.password.length < 8) {
      SetPasswordError("password plus que 8");
    }
    try {
      dispatch(send_login(data)).then((result) => {
        if (send_login.fulfilled.match(result)) {
          updateAuthToken(result.payload.token);
          if (result.payload.user.Role == "client") {
            Navigate("profile");
          } else {
            Navigate(`/${result.payload.user.Role}/dashboard`);
          }
        }
        if (send_login.rejected.match(result)) {
          SetPasswordError("email or password Incorrect");
        }
      });
    } catch (error) {
      console.log(error.message);
    }*/

    //setError(null);

    try {
      await login(data.email, data.password);
      
    } catch (err) {
      //setError("Invalid credentials. Please try again.");
      console.log(err);
    }
  };

  function InisialState() {
    setEmailError(null);
    SetPasswordError(null);
  }
  return (
    <Grid container component="main" sx={{ height: "100vh" }}>
      <CssBaseline />

      <Grid item xs={12} sm={8} md={6} component={Paper} elevation={6} square>
        <Box
          sx={{
            my: 8,
            mx: 4,
            display: "flex",
            flexDirection: "column",
            px: { xs: 2, sm: 4, md: 6, lg: 8, xl: 10 },
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
            <img
              src={LoginLogoImage}
              height="100px"
              width="auto"
              alt="logo login pbs"
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
            <Typography
              component="h1"
              variant="h5"
              fontFamily="Graphik"
              fontSize="34px"
              textAlign="right"
              fontWeight="800"
            >
              Se connecter
            </Typography>
          </Box>

          <Box
            component="form"
            noValidate
            onSubmit={handleSubmit}
            sx={{ mt: 1 }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <LabelTypography required={true}>
                  E-mail Address
                </LabelTypography>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  label="Email Address"
                  name="email"
                  autoComplete="email"
                  error={emailError == null ? false : true}
                  helperText={emailError}
                  autoFocus
                />
              </Grid>
              <Grid item xs={12}>
                <LabelTypography required={true}>Password</LabelTypography>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type="password"
                  id="password"
                  autoComplete="current-password"
                  error={passwordError == null ? false : true}
                  helperText={passwordError}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonSimple type="submit" fullWidth sx={{ mt: 3, mb: 2 }}>
                  Se connecter
                </ButtonSimple>
              </Grid>
            </Grid>
          </Box>
          <Grid container textAlign="center" spacing={2}>
            <Grid item xs={12} textAlign="center">
              <LinkTypography
                href="#"
                variant="body2"
                color="primary"
                alignItems="center"
                gutterBottom
              >
                Oublié mot de passe ?
              </LinkTypography>
            </Grid>
            <Grid item xs={12} container alignItems="center">
              <Box sx={{ width: "43%", float: "left" }}>
                <Divider />
              </Box>
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{ mx: 2, whiteSpace: "nowrap" }}
              >
                Ou
              </Typography>
              <Box sx={{ width: "43%", float: "right" }}>
                <Divider />
              </Box>
            </Grid>
            <Grid item xs={12} textAlign="center">
              <Typography variant="body2" color="textSecondary" gutterBottom>
                Don't have an account?
              </Typography>
              <LinkTypography
                href="#"
                variant="body2"
                color="primary"
                alignItems="center"
                gutterBottom
              >
                Register
              </LinkTypography>
            </Grid>
          </Grid>
        </Box>
      </Grid>
      <Grid
        item
        xs={false}
        sm={4}
        md={6}
        sx={{
          backgroundImage: `url(${LoginImage})`,
          backgroundRepeat: "no-repeat",
          backgroundColor: (t) =>
            t.palette.mode === "light"
              ? t.palette.grey[50]
              : t.palette.grey[900],
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
    </Grid>
  );
}

export default Login;
